import React, { useState } from "react";
import { positions, Provider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
// import LoginPage from './login/LoginPage';
import LoginPageNew from "./login/LoginPageOAuth";
import HomePage from "./homePage/homePage";
import ProtectedRoute from "./protectedRoute/protectedRoute";
import Mapping from "./mapping/parameterMapping";
import ProfileMapping from "./mapping/profileMapping";
import ReportConfiguration from "./reportConfiguration/reportConfiguration";
import ColorConfig from "./colorConfiguration/colorConfig";
import SignUp from "./signUp/signUp";
import IdleComponent from "./IdleComponent";
import SampleGenerator from "./sampleGenerator/sampleGenerator";
import ProfileContent from "./profileContent/redesign/ProfileContentManager";
import ParameterContent from "./parameterContent/parameterContent";
import HeaderFooter from "./headerFooter/headerFooter";
import VizappConfiguration from "./vizappConfiguration/vizappConfiguration";
import PageNotFound from "./notFound/pageNotFound";
import VersionManagement from "./versionManagement/VersionManagement";
import AssetManagement from "./assetManagement/AssetManagement";
import WebhookConfig from "./webhookConfig/webhookConfig";
import PatientDetailsConfig from "./patientDetailsConfig/PatientDetailsConfig";
import ProductRecommendationConfig from "./productRecommendations/ProductRecommendationConfig";
import ParameterOrdering from "./orderConfig/ParameterOrdering";
import OnboardingStatus from "./onboardingStatus/OnboardingStatus";
import SampleJsonViewer from "./sampleJsonViewer/SampleJsonViewer";
import UnmappedManagement from "./unmappedManagement/UnmappedManagement";
import { AccessProvider } from "./layout/AccessContext";
import { AdminProvider } from "./layout/AdminContext";

// react alert package configuration
const options = {
  timeout: 3500,
  position: positions.BOTTOM_CENTER,
};

const App = () => {
  const [editVersion, setEditVersion] = useState("");


  return (
    <div className="">
      <Router>
        {/* <NavBar /> */}
        <Provider className="mb-2" template={AlertTemplate} {...options}>
          <AdminProvider>
            <AccessProvider>
              <Switch>
                <Route path="/signup" exact component={SignUp} />

                <Route path="/login" component={LoginPageNew} exact />
                <ProtectedRoute path="/" component={HomePage} exact>
                  <IdleComponent Component={HomePage} />
                </ProtectedRoute>
                <ProtectedRoute path="/onboarding-status" component={OnboardingStatus} exact>
                  <IdleComponent Component={OnboardingStatus} />
                </ProtectedRoute>
                <ProtectedRoute path="/sample-json" component={SampleJsonViewer} exact>
                  <IdleComponent Component={SampleJsonViewer} />
                </ProtectedRoute>
                <ProtectedRoute path="/parameter-mapping" component={Mapping} exact>
                  <IdleComponent Component={Mapping} />
                </ProtectedRoute>
                <ProtectedRoute path="/unmapped-management" component={UnmappedManagement} exact>
                  <IdleComponent Component={UnmappedManagement} />
                </ProtectedRoute>
                <ProtectedRoute
                  path="/profile-mapping"
                  component={ProfileMapping}
                  exact
                >
                  <IdleComponent Component={ProfileMapping} />
                </ProtectedRoute>
                <ProtectedRoute
                  path="/report-configuration"
                  component={ReportConfiguration}
                  exact
                >
                  <IdleComponent Component={ReportConfiguration} />
                </ProtectedRoute>
                <ProtectedRoute
                  path="/color-configuration"
                  component={ColorConfig}
                  exact
                >
                  <IdleComponent Component={ColorConfig} />
                </ProtectedRoute>
                <ProtectedRoute
                  path="/profile-content"
                  component={ProfileContent}
                  exact
                  version={editVersion}
                >
                  <IdleComponent
                    Component={ProfileContent}
                    version={editVersion}
                    setEditVersion={setEditVersion}
                  />
                </ProtectedRoute>
                <ProtectedRoute
                  path="/parameter-content"
                  component={ParameterContent}
                  exact
                >
                  <IdleComponent
                    Component={ParameterContent}
                    version={editVersion}
                    setEditVersion={setEditVersion}
                  />
                </ProtectedRoute>
                <ProtectedRoute
                  path="/sample-report-generation"
                  component={SampleGenerator}
                  exact
                >
                  <IdleComponent Component={SampleGenerator} />
                </ProtectedRoute>
                <ProtectedRoute
                  path="/header-footer"
                  component={HeaderFooter}
                  exact
                >
                  <IdleComponent Component={HeaderFooter} />
                </ProtectedRoute>
                <ProtectedRoute
                  path="/vizapp-configuration"
                  component={VizappConfiguration}
                  exact
                >
                  <IdleComponent Component={VizappConfiguration} />
                </ProtectedRoute>

                <ProtectedRoute
                  path="/version-management"
                  component={VersionManagement}
                  exact
                >
                  <IdleComponent
                    Component={VersionManagement}
                    version={editVersion}
                    setEditVersion={setEditVersion}
                  />
                </ProtectedRoute>
                <ProtectedRoute
                  path="/asset-management"
                  component={AssetManagement}
                  exact
                >
                  <IdleComponent Component={AssetManagement} />
                </ProtectedRoute>
                <ProtectedRoute
                  path="/webhook-configuration"
                  component={WebhookConfig}
                  exact
                >
                  <IdleComponent Component={WebhookConfig} />
                </ProtectedRoute>
                <ProtectedRoute
                  path="/patient-details-configuration"
                  component={PatientDetailsConfig}
                  exact
                >
                  <IdleComponent Component={PatientDetailsConfig} />
                </ProtectedRoute>
                <ProtectedRoute
                  path="/product-recommendations"
                  component={ProductRecommendationConfig}
                  exact
                >
                  <IdleComponent Component={ProductRecommendationConfig} />
                </ProtectedRoute>
                <ProtectedRoute
                  path="/ordering"
                  component={ParameterOrdering}
                  exact
                >
                  <IdleComponent Component={ParameterOrdering} />
                </ProtectedRoute>

                <Route component={PageNotFound} />
              </Switch>
            </AccessProvider>
          </AdminProvider>
        </Provider>
      </Router>
    </div>
  );
};

export default App;

